import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "./components/pages/LandingPage";
import Services from "./components/pages/Services";
import OurTeam from "./components/pages/OurTeam";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";

// Document title per route — better for browser history, tabs and SEO.
const PAGE_TITLES = {
  "/": "Yaya Dental Clinic | Your Smile, Our Priority",
  "/services": "Our Services | Yaya Dental Clinic",
  "/our-team": "Our Team | Yaya Dental Clinic",
};

// Scrolls the window back to the top whenever the route changes,
// so links opened from the footer start at the top of the new page.
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = PAGE_TITLES[pathname] || "Yaya Dental Clinic";
  }, [pathname]);

  return null;
}

function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/services" element={<Services />} />
          <Route path="/our-team" element={<OurTeam />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
